import React from 'react'
import { Link } from '@inertiajs/react'
import { CellUser, CellMono } from '@/admin/shared/components/DataTable/Cell'
import type { DataTableColumn } from '@/admin/shared/components/DataTable/DataTable'
import type { User } from '../types'
import UserStatusBadge from './UserStatusBadge'

export const COLUMNS: DataTableColumn<User>[] = [
  {
    key: 'name',
    label: 'User',
    render: u => (
      <Link href={`/admin/users/${u.id}`}>
        <CellUser name={u.name} sub={u.email} />
      </Link>
    ),
  },
  {
    key: 'id',
    label: 'ID',
    render: u => <CellMono>USR-{u.id}</CellMono>,
  },
  {
    key: 'created_at',
    label: 'Joined',
    sortable: true,
    render: u => (
      <CellMono>
        {new Date(u.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
      </CellMono>
    ),
  },
  {
    key: 'status',
    label: 'Status',
    render: u => <UserStatusBadge user={u} />,
  },
]
